module.exports = __webpack_public_path__ + "img/pr-4.6b215690.png";